const defaultFilters = [
  {
    key: 'status',
    active: false,
    label: 'Status',
    options: [{
      label: 'Snoozed',
      value: 'Snoozed',
    }, {
      label: 'Scheduled',
      value: 'Scheduled',
    }, {
      label: 'Closed',
      value: 'Closed',
    }],
    showOnMain: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'statusClosedTab',
    active: false,
    label: 'Status',
    options: [{
      label: 'Dismissed',
      value: 'Dismissed',
    }, {
      label: 'Cancelled',
      value: 'Cancelled',
    }, {
      label: 'Resolved',
      value: 'Resolved',
    }, {
      label: 'Expired',
      value: 'Expired',
    }, {
      label: 'Completed',
      value: 'Completed',
    }],
    showOnMain: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'statusPendingTab',
    active: false,
    label: 'Status',
    options: [{
      label: 'Opportunities',
      value: 'Opportunities',
    }, {
      label: 'Service Requests',
      value: 'Service Requests',
    }, {
      label: 'Reschedule Requests',
      value: 'Reschedule Requests',
    },
    ],
    showOnMain: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'distance',
    active: false,
    label: 'Distance',
    options: [{
      label: '<10mi',
      value: 'Under 10mi',
    }, {
      label: '10-25mi',
      value: '10-25mi',
    }, {
      label: '>25mi',
      value: 'Over 25mi',
    }],
    showOnMain: false,
    showOnAll: false,
    activeOption: {},
  },
  {
    key: 'leadType',
    active: false,
    label: 'Type',
    options: [{
      label: 'Cooling',
      value: 'Cooling',
      showIcon: true,
    }, {
      label: 'Heating',
      value: 'Heating',
      showIcon: true,
    }, {
      label: 'Runtime',
      value: 'Runtime',
      showIcon: true,
    }, {
      label: 'Leaks',
      value: 'Leaks',
      showIcon: true,
    }],
    showOnMain: true,
    showOnAll: true,
    multiple: true,
    showNavIcon: true,
    activeOption: [],
  },
  {
    key: 'lastOccurrence',
    active: false,
    label: 'Last Occurrence',
    options: [{
      label: 'Today',
      value: 'Today',
    }, {
      label: 'Yesterday',
      value: 'Yesterday',
    }, {
      label: 'Last Week',
      value: 'Last Week',
    }],
    showOnMain: false,
    showOnAll: true,
    activeOption: {},
  },
  {
    key: 'sortBy',
    active: false,
    label: 'Sort By',
    options: [{
      label: 'Unit Age',
      value: 'age',
    }, {
      label: 'Distance',
      value: 'distance',
    }, {
      label: 'Last Occurred',
      value: 'time',
    }],
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    activeOption: {},
  }, {
    key: 'unitAge',
    active: false,
    label: 'Unit Age',
    options: [{
      label: '<6yrs',
      value: 'Under 6yr',
    }, {
      label: '6-10yrs',
      value: '6-10yr',
    }, {
      label: '>10yrs',
      value: 'Over 10yr',
    }],
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    activeOption: {},
  }, {
    key: 'dateCreated',
    active: false,
    label: 'Date',
    options: [{
      label: 'Last Week',
      value: 'lastWeek',
    }, {
      label: 'Last Month',
      value: 'lastMonth',
    }, {
      label: 'Last Year',
      value: 'lastYear',
    },
    {
      label: 'Custom',
      value: 'custom',
    }],
    selectedDateRange: {
      start: null,
      end: null,
    },
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'visitType',
    active: false,
    label: 'Visit Type',
    options: [{
      label: 'Service',
      value: 'Service',
    }, {
      label: 'Emergency',
      value: 'Emergency',
    }, {
      label: 'Tune Up',
      value: 'TuneUp',
    }, {
      label: 'Troubleshoot',
      value: 'Troubleshoot',
    }, {
      label: 'Onboarding',
      value: 'Onboarding',
    }, {
      label: 'Quote',
      value: 'Quote',
    }],
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'serviceCategory',
    active: false,
    label: 'Service Category',
    options: [{
      label: 'HVAC',
      value: 'HVAC',
    }, {
      label: 'Plumbing',
      value: 'Plumbing',
    }, {
      label: 'Water Quality',
      value: 'Water Quality',
    }, {
      label: 'Septic',
      value: 'Septic',
    }, {
      label: 'Electrical',
      value: 'Electrical',
    }, {
      label: 'Garage Door',
      value: 'Garage Door',
    }, {
      label: 'Air Quality',
      value: 'Air Quality',
    }, {
      label: 'Other',
      value: 'Other',
    }],
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    activeOption: {},
  },
  {
    key: 'techs',
    active: false,
    label: 'Technician',
    options: [],
    showOnMain: true,
    showOnAll: true,
    showNavIcon: true,
    showSearch: true,
    activeOption: {},
  }];

const initialState = () => ({
  leadList: [],
  pressureConversion: 248.84,
  activeTab: 'pending',
  selectedCorp: 1,
  selectedAlert: {},
  chronicType: null,
  chronicNote: null,
  partnerConfig: {},
  loadingPartnerConfig: false,
  showRightSidebar: false,
  currentPosition: null,
  isActioned: false,
  isNoteActioned: false,
  serviceSummary: {
    pending: 0,
    snoozed: 0,
    scheduled: 0,
    incomplete: 0,
    closed: 0,
  },
  confirmedTimeOptions: [
    {
      label: '8am',
      value: '08:00:00',
    },
    {
      label: '9am',
      value: '09:00:00',
    },
    {
      label: '10am',
      value: '10:00:00',
    },
    {
      label: '11am',
      value: '11:00:00',
    },
    {
      label: '12pm',
      value: '12:00:00',
    },
    {
      label: '1pm',
      value: '13:00:00',
    },
    {
      label: '2pm',
      value: '14:00:00',
    },
    {
      label: '3pm',
      value: '15:00:00',
    },
    {
      label: '4pm',
      value: '16:00:00',
    },
    {
      label: '5pm',
      value: '17:00:00',
    },
  ],
  serviceFilters: defaultFilters,
  defaultFilters,
  serviceRequestList: [],
  conditionList: [],
  visitTypeList: [],
  processing: false,
  serviceCategoryList: [],
  showActionModal: false,
  actionModalView: false,
  serviceInfo: {},
  showServiceBottomSheet: false,
  serviceBottomsheetView: '',
  allPastServices: [],
  serviceSearch: '',
  actionRequest: {},

  customerBalance: 0,
  jobList: [],
  customerNoteList: [],
  selectedNote: {},

  serviceReference: '',
  // detail
  leadDetail: {},
  activeAlertList: [],
  systemInsightList: [],
  pastAlertList: [],
  pastLeakAlertList: [],
  recentCycleList: [],
  pastServiceList: [],
  // loader
  loadingDetail: false,
  loadingCycles: false,
  loadingAlerts: false,
  loadingServices: false,
  loadingSummary: false,
  loadingLeads: false,
  loadingServiceRequest: false,
  loadingJobs: false,
  loadingNotes: false,
  uploadingInvoice: false,
});

export default initialState;
